import { render, staticRenderFns } from "./warnType.vue?vue&type=template&id=120fa096&scoped=true"
import script from "./warnType.vue?vue&type=script&lang=js"
export * from "./warnType.vue?vue&type=script&lang=js"
import style0 from "./warnType.vue?vue&type=style&index=0&id=120fa096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120fa096",
  null
  
)

export default component.exports